import React from 'react'
import { UserConsumer } from './UserProvider'

export const withContext = (Component) => {
    return (props) => (
        <UserConsumer>
            {({ state, updateContextVal, showConfetti }) => (
                <Component {...props} context={state} updateContextVal={updateContextVal} showConfetti={showConfetti} />
            )}
        </UserConsumer>
    )
}
